"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirplaneLarge = exports.Airplane = exports.AirplaneStraight = exports.AirplaneAngle = void 0;
var Angle_1 = require("./Airplane/Angle");
Object.defineProperty(exports, "AirplaneAngle", { enumerable: true, get: function () { return __importDefault(Angle_1).default; } });
var Straight_1 = require("./Airplane/Straight");
Object.defineProperty(exports, "AirplaneStraight", { enumerable: true, get: function () { return __importDefault(Straight_1).default; } });
var AirplaneSVG_1 = require("./Airplane/SVG/AirplaneSVG");
Object.defineProperty(exports, "Airplane", { enumerable: true, get: function () { return __importDefault(AirplaneSVG_1).default; } });
var AirplaneLargeSVG_1 = require("./Airplane/SVG/AirplaneLargeSVG");
Object.defineProperty(exports, "AirplaneLarge", { enumerable: true, get: function () { return __importDefault(AirplaneLargeSVG_1).default; } });
